// @flow

import { useLocation } from 'react-router-dom';

import { selectCartTotal, selectUnusedDiscounts } from '@gandi/cart';

import { useAppSelector } from 'src/hooks/useAppSelector';

import DiscountRow from './DiscountRow';

import styles from './DiscountRows.scss';

type Props = {
  setSuccess: React.ReactSetStateFunction<?string>,
};

export function DiscountRows({ setSuccess }: Props): React.MixedElement | null {
  const location = useLocation();
  const overviewPage = location.pathname.includes('overview');
  const total = useAppSelector(selectCartTotal);
  const unusedDiscounts = useAppSelector(selectUnusedDiscounts);

  if (!overviewPage) return null;

  return (
    <div className={styles.discounts}>
      {(total.discounts || []).map((discount, idx) => (
        <DiscountRow
          key={discount.code || idx}
          discount={discount}
          setSuccess={setSuccess}
        />
      ))}
      {(unusedDiscounts || []).map(unusedDiscount => (
        <DiscountRow
          key={unusedDiscount.id}
          discount={unusedDiscount}
          setSuccess={setSuccess}
        />
      ))}
    </div>
  );
}
